import type {
  Conversation,
  ConversationUpdate,
  NewConversation,
} from "@/conversations/types";
import { omit } from "lodash-es";
import { apiClient } from "./apiClient";

export const conversationsGateway = {
  async listConversationsByHouseId(
    houseId: number,
  ): Promise<Array<Conversation>> {
    return await apiClient.get(`/api/conversations/house/${houseId}`);
  },

  async listConversationsByContactId(
    contactId: string,
  ): Promise<Array<Conversation>> {
    return await apiClient.get(`/api/conversations/contact/${contactId}`);
  },

  async getConversation(id: string): Promise<Conversation> {
    return await apiClient.get(`/api/conversations/${id}`);
  },

  async createConversation(
    conversation: NewConversation,
  ): Promise<Conversation> {
    return await apiClient.post(`/api/conversations`, conversation);
  },

  async updateConversation(
    conversation: ConversationUpdate,
  ): Promise<Conversation> {
    return await apiClient.patch(
      `/api/conversations/${conversation.id}`,
      omit(conversation, ["id"]),
    );
  },

  async deleteConversation(id: string): Promise<void> {
    await apiClient.delete(`/api/conversations/${id}`);
  },
};
